/* index.js */

"use strict";

module.exports = {
    TextEditorComponent: require("./text_editor/TextEditorComponent"),
};
